export const modulePaths = ['edp-lazy-load'];
export const moduleEndpoints = ['/sport/'];
